
import {Component, Vue} from "vue-property-decorator";
import KademeSecici from "@/components/izinler/KademeSecici.vue";
import IslemSecici from "@/components/izinler/IslemSecici.vue";
import {DuzDugum, duzDugumler, gosterimAgaciKur} from "@/components/izinler/modulAgaci";
import {kural1Kilidi, kural1Uygula, ustHaritasiKur, UstHaritasi} from "@/components/izinler/kural1";
import {
  ModulDugumu,
  ModulYetkiSatiri,
  UrunGrubu,
  YetkiKademe,
  modulEtiketi,
  modulIkonu,
  rolRengi,
} from "@/enum/YetkiModulleri";
import {benTazele} from "@/plugins/benTazele";
import {
  GecisHatalari,
  Hucre,
  HucreHaritasi,
  Uyum,
  gecisHatalari,
  gonderilecekRoller,
  hucreAyni,
  hucreMetni,
  kendiUyarisiylaAdaptor,
  uyumHesapla,
  uyumOzeti,
} from "@/components/yetki-gecisi/yetkiGecisi";

interface GecisRolu {
  id: number;
  ad: string;
  sinif: string;
  sablon: string | null;
  kaynak: string;
  ad_degismis: boolean;
  silinmis: boolean;
  aktif_kullanici: number;
  tam_yetki: boolean;
}

const SINIF_ETIKETI: { [sinif: string]: string } = {
  sistem: "Sistem",
  ozel: "Özel",
  diger: "Diğer",
  yonetici: "Yönetici",
};

const UYUM_GORUNUMU: { [u in Uyum]: { etiket: string; kisa: string; ikon: string } } = {
  ayni: {etiket: "Bugünle aynı", kisa: "aynı", ikon: "mdi-check-circle-outline"},
  dar: {etiket: "Daralıyor", kisa: "dar", ikon: "mdi-arrow-down-bold-circle-outline"},
  genis: {etiket: "Genişliyor", kisa: "geniş", ikon: "mdi-arrow-up-bold-circle-outline"},
  farkli: {etiket: "Farklı (biri dar biri geniş)", kisa: "farklı", ikon: "mdi-swap-vertical-circle-outline"},
};
const UYUM_SIRASI: Uyum[] = ["ayni", "dar", "genis", "farkli"];

// Düğme yolunda DURDU'nun tüm sebepleri (isaret_okunamadi, data_nesne_degil) için tek metin.
const DURDU_VARSAYILAN = "Bu büro düğmeyle geçirilemiyor; destek ekibine başvurun. Büronuz eski yetki sisteminde.";
const BAYAT_TIPI = "yetki_gecisi_onizleme_bayat";
const YENI_MODDA_TIPI = "yetki_gecisi_yeni_modda";

function bosHatalar(): GecisHatalari {
  return {genel: [], rol: {}, hucre: {}};
}

function yeniModdaMi(hata: any): boolean {
  const yanit = hata && hata.response;
  return !!yanit && yanit.status === 409 && !!yanit.data && yanit.data.type === YENI_MODDA_TIPI;
}

function hucreOku(ham: any): Hucre {
  const h = ham || {};
  return {kademe: h.kademe || YetkiKademe.GIZLI, ekle: !!h.ekle, degistir: !!h.degistir, sil: !!h.sil};
}

// "Yalnız Sistem Yöneticisi" yalnız sunucu bunu söylediğinde (`sebep`); öbür 403'lerde sunucu mesajı (StatusCodeHelper.error403 ayrımı).
function sunucuMesaji(hata: any, varsayilan: string): string {
  const yanit = hata && hata.response;
  const data = (yanit && yanit.data) || {};
  if (yanit && yanit.status === 403 && data.sebep === "yalniz_yonetici") {
    return "Bu işlem yalnız Sistem Yöneticisi tarafından yapılabilir.";
  }
  const mesaj = data.message;
  if (typeof mesaj === "string" && mesaj !== "") {
    return mesaj;
  }
  return yanit && yanit.status === 403 ? "İşlemi gerçekleştirmeye yetkiniz yoktur." : varsayilan;
}

@Component({
  components: {KademeSecici, IslemSecici},
})
export default class YetkiGecisiEkrani extends Vue {
  yukleniyor = false;
  // Her yüklemeye artan numara; yalnız en son yüklemenin sonucu yazılır.
  yuklemeNo = 0;
  yuklemeHatasi: string | null = null;
  // Önizlemenin rol dışı kısmı (durum, sebep, girdi_damgasi, sayilar, kullanici, uyarilar, onceki_gecis).
  veri: any = null;
  roller: GecisRolu[] = [];
  // rol id -> modül -> düzenlenen hücre (KademeSecici/IslemSecici bu nesneleri doğrudan değiştirir).
  satirlar: { [rolId: string]: { [modul: string]: ModulYetkiSatiri } } = {};
  onerilen: { [rolId: string]: HucreHaritasi } = {};
  bugun: { [rolId: string]: HucreHaritasi } = {};
  duyarli: { [rolId: string]: { [modul: string]: boolean } } = {};
  seciliRolId: number | null = null;

  acikGruplar: { [urun: string]: boolean } = {};
  acikDugumler: { [modul: string]: boolean } = {};

  onayAcik = false;
  gonderiliyor = false;
  gonderimHatasi: string | null = null;
  bayatUyarisi = false;
  hatalar: GecisHatalari = bosHatalar();

  mounted() {
    this.yukle();
  }

  // Sayfadan çıkılınca bekleyen önizlemenin sonucu yazılmaz: yeni modda 409 mesaj ve zorla /ben üretmesin.
  beforeDestroy() {
    this.yuklemeNo++;
  }

  // ---------- yükleme ----------

  async yukle() {
    const no = ++this.yuklemeNo;
    this.yukleniyor = true;
    this.yuklemeHatasi = null;
    try {
      // 409'u (yeni modda, sürüyor) bu ekran kendisi karşılar; genel uyarı yalnız bu istekte susar (uygula ile aynı).
      const govde: any = await this.$http.get("/api/v1/yetki-gecisi/onizleme", {
        adapter: kendiUyarisiylaAdaptor(this.$http.defaults && this.$http.defaults.adapter, [409]),
      });
      if (no !== this.yuklemeNo) {
        return;
      }
      const data = govde && govde.data;
      if (!data || !Array.isArray(data.roller) || typeof data.girdi_damgasi !== "string") {
        throw new Error("Önizleme yanıtı beklenen biçimde değil.");
      }
      this.onizlemeyiYaz(data);
    } catch (hata) {
      if (no !== this.yuklemeNo) {
        return;
      }
      this.veri = null;
      if (yeniModdaMi(hata)) {
        await this.yeniModdaCik(hata);
        return;
      }
      this.yuklemeHatasi = sunucuMesaji(hata, "Önizleme yüklenemedi. Büronuz eski yetki sisteminde.");
    } finally {
      if (no === this.yuklemeNo) {
        this.yukleniyor = false;
      }
    }
  }

  onizlemeyiYaz(data: any) {
    const roller: GecisRolu[] = [];
    const satirlar: { [rolId: string]: { [modul: string]: ModulYetkiSatiri } } = {};
    const onerilen: { [rolId: string]: HucreHaritasi } = {};
    const bugun: { [rolId: string]: HucreHaritasi } = {};
    const duyarli: { [rolId: string]: { [modul: string]: boolean } } = {};

    data.roller.forEach((r: any) => {
      const k = String(r.id);
      roller.push({
        id: r.id, ad: r.ad, sinif: r.sinif, kaynak: String(r.kaynak ?? ""), sablon: r.sablon ?? null, ad_degismis: !!r.ad_degismis,
        silinmis: !!r.silinmis, aktif_kullanici: Number(r.aktif_kullanici) || 0, tam_yetki: !!r.tam_yetki,
      });
      satirlar[k] = {};
      onerilen[k] = {};
      bugun[k] = {};
      duyarli[k] = {};
      // Yönetici rolünde yetkiler boştur (satır yazılmaz).
      (r.tam_yetki ? [] : (r.yetkiler || [])).forEach((y: any) => {
        const o = hucreOku(y);
        satirlar[k][y.modul] = {
          modul: y.modul, kademe: o.kademe as YetkiKademe, ekle: o.ekle, degistir: o.degistir, sil: o.sil,
          urun: y.urun ?? null, etiket: y.etiket ?? null, ust: y.ust ?? null,
        };
        onerilen[k][y.modul] = o;
        bugun[k][y.modul] = hucreOku(y.bugun);
        duyarli[k][y.modul] = !!y.duyarli;
      });
    });

    this.veri = {
      durum: data.durum, sebep: data.sebep ?? null, girdi_damgasi: data.girdi_damgasi,
      sayilar: data.sayilar || {}, kullanici: data.kullanici || {}, uyarilar: data.uyarilar || {},
      onceki_gecis: data.onceki_gecis || null,
    };
    this.roller = roller;
    this.satirlar = satirlar;
    this.onerilen = onerilen;
    this.bugun = bugun;
    this.duyarli = duyarli;
    this.hatalar = bosHatalar();
    // Seçili rol hâlâ varsa korunur; yoksa ilk tam yetkisiz rol.
    if (!roller.some((r) => r.id === this.seciliRolId)) {
      const ilk = roller.find((r) => !r.tam_yetki) || roller[0];
      this.seciliRolId = ilk ? ilk.id : null;
    }
  }

  // ---------- durum ----------

  get hazir(): boolean {
    return !!this.veri && this.veri.durum === "HAZIR";
  }

  get durdu(): boolean {
    return !!this.veri && this.veri.durum === "DURDU";
  }

  get durduMetni(): string {
    return DURDU_VARSAYILAN;
  }

  // Önceki geçişten kayıtlı ayarı olan büroda (düğmeyle yeniden geçiş) tek satırlık bilgi.
  get oncekiGecisMetni(): string {
    const o = this.veri && this.veri.onceki_gecis;
    if (!o || o.var !== true) {
      return "";
    }
    const tarih = (ham: any) => (typeof ham === "string" && ham !== "" ? this.$helper.tarihStr(ham).split("/").join(".") : "-");
    return `Büronuz daha önce yeni sistemi kullandı (geçiş: ${tarih(o.tarih)}, geri alma: ${tarih(o.geri_alindi)}). Önceki ayarlarınız önerildi.`;
  }

  get onayKapali(): boolean {
    return !this.hazir || this.yukleniyor || !!this.yuklemeHatasi || this.gonderiliyor;
  }

  get duzenlemeKapali(): boolean {
    return !this.hazir || this.gonderiliyor;
  }

  // ---------- özet ----------

  get rolSayisi(): number {
    const s = this.veri && this.veri.sayilar;
    return s && typeof s.rol_sayisi === "number" ? s.rol_sayisi : this.roller.filter((r) => !r.tam_yetki).length;
  }

  get bugundenFarkli(): number {
    return Object.keys(this.satirlar).reduce((toplam, k) => {
      const o = uyumOzeti(this.satirlar[k], this.bugun[k] || {});
      return toplam + o.dar + o.genis + o.farkli;
    }, 0);
  }

  get degistirilen(): number {
    const govde = this.gonderilecek;
    return Object.keys(govde).reduce((t, k) => t + Object.keys(govde[k]).length, 0);
  }

  get kaybiOlan(): number {
    const k = this.veri && this.veri.kullanici;
    return (k && Number(k.kaybi_olan)) || 0;
  }

  get cokRolluKaybiOlan(): number {
    const k = this.veri && this.veri.kullanici;
    return (k && Number(k.cok_rollu_kaybi_olan)) || 0;
  }

  get lejant() {
    return UYUM_SIRASI.map((u) => ({uyum: u, etiket: UYUM_GORUNUMU[u].etiket, ikon: UYUM_GORUNUMU[u].ikon}));
  }

  get uyariMetinleri(): string[] {
    const u = (this.veri && this.veri.uyarilar) || {};
    const metin: string[] = [];
    const kisi = u.kisi_ozel || {};
    if (Number(kisi.satir) > 0) {
      const moduller = (kisi.moduller || []).map((m: string) => this.modulAdi(m)).join(", ");
      metin.push(`Kişiye özel yetki: ${kisi.kullanici} kullanıcıda ${kisi.satir} kayıt var`
        + (moduller ? ` (${moduller})` : "") + ". Geçiş bunlara dokunmaz.");
    }
    const dogrudan = u.dogrudan_izin || {};
    if (Number(dogrudan.kullanici) > 0) {
      metin.push(`Rol dışı izin: ${dogrudan.kullanici} kullanıcıya doğrudan verilmiş izin yeni sisteme taşınmaz`
        + ((dogrudan.izinler || []).length ? ` (${dogrudan.izinler.join(", ")})` : "") + ".");
    }
    const eksik: number[] = u.beklenen_sistem_rolu_yok || [];
    if (eksik.length) {
      metin.push(`Beklenen sistem rolü büroda yok (rol no: ${eksik.join(", ")}).`);
    }
    return metin;
  }

  // Uyarıdaki modül anahtarının adı: önizleme satırının API etiketi, yoksa okunur yedek.
  modulAdi(modul: string): string {
    const k = Object.keys(this.satirlar).find((id) => !!this.satirlar[id][modul]);
    return modulEtiketi(modul, k ? this.satirlar[k][modul].etiket : null);
  }

  // ---------- rol seçimi ----------

  get seciliRol(): GecisRolu | null {
    return this.roller.find((r) => r.id === this.seciliRolId) || null;
  }

  get seciliIndex(): number {
    return Math.max(0, this.roller.findIndex((r) => r.id === this.seciliRolId));
  }

  get seciliSatirlar(): { [modul: string]: ModulYetkiSatiri } {
    return this.seciliRolId === null ? {} : (this.satirlar[String(this.seciliRolId)] || {});
  }

  rolSec(id: number) {
    this.seciliRolId = id;
  }

  rolRengi(index: number): string {
    return rolRengi(index);
  }

  sinifEtiketi(sinif: string): string {
    return SINIF_ETIKETI[sinif] || sinif;
  }

  ozetParcalari(rolId: number): Array<{ uyum: Uyum; sayi: number; kisa: string }> {
    const k = String(rolId);
    const o = uyumOzeti(this.satirlar[k] || {}, this.bugun[k] || {});
    return UYUM_SIRASI.filter((u) => o[u] > 0).map((u) => ({uyum: u, sayi: o[u], kisa: UYUM_GORUNUMU[u].kisa}));
  }

  // ---------- modül ağacı (rol matrisiyle aynı kurucular) ----------

  get gosterimAgaci(): UrunGrubu[] {
    const satirlar = this.seciliSatirlar;
    const urun: { [m: string]: string | null | undefined } = {};
    const etiket: { [m: string]: string | null | undefined } = {};
    Object.keys(satirlar).forEach((m) => {
      urun[m] = satirlar[m].urun;
      etiket[m] = satirlar[m].etiket;
    });
    return gosterimAgaciKur(Object.keys(satirlar), urun, etiket);
  }

  duzDugumler(dugumler: ModulDugumu[]): DuzDugum[] {
    return duzDugumler(dugumler);
  }

  dugumGorunur(node: DuzDugum): boolean {
    return node.ustZinciri.every((modul) => this.dugumAcik(modul));
  }

  grupAcik(urun: string): boolean {
    return this.acikGruplar[urun] !== false;
  }

  grupToggle(urun: string) {
    this.$set(this.acikGruplar, urun, !this.grupAcik(urun));
  }

  dugumAcik(modul: string): boolean {
    return this.acikDugumler[modul] === true;
  }

  dugumToggle(modul: string) {
    this.$set(this.acikDugumler, modul, !this.dugumAcik(modul));
  }

  grupModulSayisi(grup: UrunGrubu): number {
    const say = (dugumler: ModulDugumu[]): number =>
      dugumler.reduce((toplam, d) => toplam + 1 + say(d.cocuklar || []), 0);
    return say(grup.dugumler);
  }

  modulIkonu(modul: string): string {
    return modulIkonu(modul);
  }

  // ---------- hücre ----------

  private get seciliAnahtar(): string {
    return String(this.seciliRolId);
  }

  uyum(modul: string): Uyum {
    const b = (this.bugun[this.seciliAnahtar] || {})[modul];
    const s = this.seciliSatirlar[modul];
    return b && s ? uyumHesapla(b, s) : "ayni";
  }

  uyumGorunumu(modul: string) {
    return UYUM_GORUNUMU[this.uyum(modul)];
  }

  bugunMetni(modul: string): string {
    const b = (this.bugun[this.seciliAnahtar] || {})[modul];
    return b ? hucreMetni(b) : "";
  }

  onerilenMi(modul: string): boolean {
    const o = (this.onerilen[this.seciliAnahtar] || {})[modul];
    const s = this.seciliSatirlar[modul];
    return !o || !s || hucreAyni(o, s);
  }

  // Duyarlılık sunucunun önerilen için verdiği işarettir; seçilen bugünle aynıysa gösterilmez.
  duyarliGoster(modul: string): boolean {
    return !!(this.duyarli[this.seciliAnahtar] || {})[modul] && this.uyum(modul) !== "ayni";
  }

  get ustHaritasi(): UstHaritasi {
    return ustHaritasiKur(this.seciliSatirlar);
  }

  kademeKilidi(modul: string): YetkiKademe | null {
    return kural1Kilidi(modul, this.seciliSatirlar, this.ustHaritasi);
  }

  // Rol matrisindeki gibi: Düzenle dışında bayraklar kapanır, Kural 1 üstleri en az Görüntüle'ye çıkarır.
  kademeDegisti(modul: string) {
    const satir = this.seciliSatirlar[modul];
    if (!satir) {
      return;
    }
    if (satir.kademe !== YetkiKademe.DUZENLE) {
      satir.ekle = false;
      satir.degistir = false;
      satir.sil = false;
    }
    kural1Uygula(this.seciliSatirlar, this.ustHaritasi);
  }

  private hucreAta(modul: string, h: Hucre | undefined) {
    const satir = this.seciliSatirlar[modul];
    if (!satir || !h) {
      return;
    }
    satir.kademe = h.kademe as YetkiKademe;
    satir.ekle = h.ekle;
    satir.degistir = h.degistir;
    satir.sil = h.sil;
  }

  hucreOnerilene(modul: string) {
    this.hucreAta(modul, (this.onerilen[this.seciliAnahtar] || {})[modul]);
    this.kademeDegisti(modul);
  }

  hucreBugunku(modul: string) {
    this.hucreAta(modul, (this.bugun[this.seciliAnahtar] || {})[modul]);
    this.kademeDegisti(modul);
  }

  rolOnerilene() {
    Object.keys(this.seciliSatirlar).forEach((m) => this.hucreAta(m, (this.onerilen[this.seciliAnahtar] || {})[m]));
    kural1Uygula(this.seciliSatirlar, this.ustHaritasi);
  }

  rolBugunku() {
    Object.keys(this.seciliSatirlar).forEach((m) => this.hucreAta(m, (this.bugun[this.seciliAnahtar] || {})[m]));
    kural1Uygula(this.seciliSatirlar, this.ustHaritasi);
  }

  // ---------- 422 işaretleri ----------

  rolHatali(rolId: number): boolean {
    const k = String(rolId);
    return (this.hatalar.rol[k] || []).length > 0 || Object.keys(this.hatalar.hucre[k] || {}).length > 0;
  }

  get seciliRolHatalari(): string[] {
    return this.hatalar.rol[this.seciliAnahtar] || [];
  }

  hucreHatasi(modul: string): string[] {
    return (this.hatalar.hucre[this.seciliAnahtar] || {})[modul] || [];
  }

  // ---------- onay ----------

  // Yalnız önerilenden farklı hücreler; sunucu gerisini önerilenle tamamlar.
  get gonderilecek(): { [rolId: string]: HucreHaritasi } {
    return gonderilecekRoller(this.satirlar, this.onerilen);
  }

  onayAc() {
    if (this.onayKapali) {
      return;
    }
    this.onayAcik = true;
  }

  async uygula() {
    if (this.onayKapali || !this.veri) {
      return;
    }
    this.onayAcik = false;
    this.gonderiliyor = true;
    this.gonderimHatasi = null;
    this.bayatUyarisi = false;
    this.hatalar = bosHatalar();

    let govde: any;
    try {
      // 409/422'yi bu ekran kendisi gösterir; genel uyarı yalnız bu istekte susar (D-app-001, master'da da).
      govde = await this.$http.post("/api/v1/yetki-gecisi/uygula", {
        damga: this.veri.girdi_damgasi,
        roller: this.gonderilecek,
      }, {adapter: kendiUyarisiylaAdaptor(this.$http.defaults && this.$http.defaults.adapter, [409, 422])});
    } catch (hata) {
      this.gonderiliyor = false;
      await this.gonderimHatasiniIsle(hata);
      return;
    }

    const sonuc = (govde && govde.data) || {};
    this.$toast.success(sonuc.mesaj || "Büronuz yeni yetki sistemine geçti.");
    // Mod /ben'den okunur; zorla tazelenince Kullanıcı İzinleri ekranı yeni moda döner.
    const tazelendi = await benTazele({force: true});
    if (!tazelendi) {
      this.$toast.warning("Yeni yetki ekranını görmek için sayfayı yenileyin.");
    }
    this.gonderiliyor = false;
    this.$emit("tamamlandi", sonuc);
  }

  // Büro zaten yeni modda (başka oturum geçirmiş): ekran bayat, /ben tazelenir ve sayfadan çıkılır.
  async yeniModdaCik(hata: any) {
    this.$toast.info(sunucuMesaji(hata, "Büronuz zaten yeni yetki sisteminde."));
    const tazelendi = await benTazele({force: true});
    if (!tazelendi) {
      this.$toast.warning("Yeni yetki ekranını görmek için sayfayı yenileyin.");
    }
    this.$emit("kapat");
  }

  async gonderimHatasiniIsle(hata: any) {
    const yanit = hata && hata.response;
    const status = yanit ? yanit.status : null;
    const data = (yanit && yanit.data) || {};

    if (status === 409 && data.type === BAYAT_TIPI) {
      this.bayatUyarisi = true;
      await this.yukle();
      return;
    }
    if (yeniModdaMi(hata)) {
      await this.yeniModdaCik(hata);
      return;
    }
    if (status === 422) {
      this.hatalar = gecisHatalari(data.errors);
      this.gonderimHatasi = "Bazı seçimler kabul edilmedi; işaretli rolleri ve satırları düzeltip yeniden onaylayın. "
        + "Büronuz eski yetki sisteminde.";
      return;
    }
    this.gonderimHatasi = sunucuMesaji(hata, "Geçiş tamamlanamadı; büronuz eski yetki sisteminde çalışmaya devam ediyor.");
  }
}
